module.exports = __webpack_public_path__ + "img/ArrowUp.5f80d02b.svg";